export const getInvoiceTitleField = () => {
  return 'number';
};
